import { render } from "./qualityInspectionForm.vue?vue&type=template&id=c0efa120&scoped=true"
import script from "./qualityInspectionForm.vue?vue&type=script&lang=js"
export * from "./qualityInspectionForm.vue?vue&type=script&lang=js"

import "./qualityInspectionForm.vue?vue&type=style&index=0&id=c0efa120&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0efa120"]])

export default __exports__